import { SessionProposalModal } from './SessionProposalModal';
import { DappTxRequestModal } from './DappTxRequestModal';
import { DappSignRequestModal } from './DappSignRequestModal';

/**
 * Global WalletConnect modals — session-approval and dApp-transaction prompts.
 * Rendered once inside the provider so they surface on any page a request
 * arrives, independent of which vault view is open.
 */
export function WalletConnectModals() {
  return (
    <>
      <SessionProposalModal />
      <DappTxRequestModal />
      <DappSignRequestModal />
    </>
  );
}
